import { axiosClient } from '../axios';

export default async function getRoiContacts(clientId) {
  return axiosClient.get(`roi/${clientId}`, { withCredentials: true });
}
